import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'BET',
    callsign: 'BETHD',
    logoUrl: 'https://imgx.fubo.tv/station_logos/bet_c.png',
    slug: 'bet',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="BETHD"
        title="Watch BET live online with Fubo"
        networkName="BET"
      />
    </>
  )
}
